import { parseISO } from "date-fns";
import React from "react";

import { faCircleCheck, faCircleExclamation } from "@fortawesome/pro-solid-svg-icons";

import { Icon, Text, TextDate } from "@performyard/py-components";
import { EmployeeSummary } from "@performyard/service-contracts";

import { BulletListSection } from "../components/BulletListSection";
import { StatCard, StatRow, StatRows } from "../components/StatCard";

export const ReviewsSection: React.FC<{ summary: EmployeeSummary }> = ({ summary }) => {
	const reviewsCount = summary.signal_counts.reviews;
	const stats = summary.reviews_stats;
	const insights = summary.reviews_insights;

	return (
		<div className="mt-1 flex flex-col gap-2">
			<div className="flex gap-2" data-testid="reviews-counts">
				{stats !== null ? (
					<>
						{/* Assigned comes from the due-window reviews_stats query — distinct from
						    signal_counts.reviews (submit-window). It replaces the Total Reviews tile
						    when the stats block is present. */}
						<StatCard label="Assigned" value={stats.assigned} testId="reviews-stat-assigned" />
						<StatCard label="Review Activity" testId="reviews-stat-activity">
							<StatRows>
								<StatRow
									label="Completed"
									value={stats.completed}
									icon={<Icon icon={faCircleCheck} size={12} color="green-5" />}
									testId="reviews-stat-completed"
								/>
								<StatRow
									label="Overdue"
									value={stats.overdue}
									icon={<Icon icon={faCircleExclamation} size={12} color="red-5" />}
									testId="reviews-stat-overdue"
								/>
							</StatRows>
						</StatCard>
						<StatCard
							label="Forms Authored for Others"
							value={stats.forms_authored_for_others}
							testId="reviews-stat-forms-authored"
						/>
						<StatCard label="Last Review" testId="reviews-stat-last-review">
							{stats.last_review_date === null ? (
								<Text size="heading-5" weight="semi-bold" color="neutral-9" wrap={false}>
									—
								</Text>
							) : (
								<TextDate
									date={parseISO(stats.last_review_date)}
									hasTime={false}
									dateSize="small"
									size="heading-5"
									weight="semi-bold"
									color="neutral-9"
									wrap={false}
								/>
							)}
						</StatCard>
					</>
				) : (
					<StatCard label="Total Reviews" value={reviewsCount} testId="reviews-count-total" />
				)}
			</div>

			{insights !== null ? (
				<div className="flex flex-col gap-3" data-testid="reviews-insights">
					<BulletListSection title="Strengths" items={insights.strengths} testId="reviews-strengths" />
					<BulletListSection
						title="Areas of Opportunities"
						items={insights.areas_of_opportunity}
						testId="reviews-areas-of-opportunity"
					/>
					<BulletListSection
						title="Goals — From Review Creation"
						items={insights.goals_from_review_creation}
						testId="reviews-goals-from-creation"
					/>
					<BulletListSection
						title="Goals — From Review Discussions"
						items={insights.goals_from_review_discussions}
						testId="reviews-goals-from-discussions"
					/>
				</div>
			) : null}
		</div>
	);
};
